import { apiRequest } from '../api/client';
import { createTrainingApi } from '../training/training-api';

/** API surface for the coach workspace. It intentionally has no billing methods. */
export function createCoachApi({ fetchImpl } = {}) {
  const request = (path, options) => apiRequest(path, { ...options, fetchImpl });
  const training = createTrainingApi({ fetchImpl });
  return {
    listMembers: () => request('/members').then((result) => result.members || []),
    getMember: (id) => request(`/members/${encodeURIComponent(id)}`),
    listMemberAttendance: (id) => request(`/members/${encodeURIComponent(id)}/attendance`).then((result) => result.checkins || []),
    listExercises: training.listExercises,
    listMemberRoutines: training.listMemberRoutines,
    createRoutine: training.createRoutine,
    updateRoutine: training.updateRoutine,
    archiveRoutine: training.archiveRoutine,
    restoreSubstitution: training.restoreSubstitution,
    getMemberProgress: training.getMemberProgress,
    listMemberSessions: training.listMemberSessions,
  };
}

export const coachApi = createCoachApi();
